<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <timing-month-module :dto="config.timing" :options="options" :compare="true"></timing-month-module>

        <div class="card shadow mb-3">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
            </div>
            <div class="card-body">

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">
                        <i class="fas fa-info-circle text-muted"
                           style=""
                           data-toggle="tooltip"
                           data-placement="top"
                           :title="$info['calculation.columns']"></i>
                        Anzuzeigende Spalten
                    </legend>

                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label><b>PZN</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-name"
                                           v-model="config.pznName">
                                    <label class="form-check-label" for="pzn-name">
                                        Artikelname
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-menge-einheit"
                                           v-model="config.pznMengeEinheit">
                                    <label class="form-check-label" for="pzn-menge-einheit">
                                        Menge und Einheit
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-dar"
                                           v-model="config.pznDar">
                                    <label class="form-check-label" for="pzn-dar">
                                        Darreichungsform
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="pzn-anbieter"
                                           v-model="config.pznAnbieter">
                                    <label class="form-check-label" for="pzn-anbieter">
                                        Anbieter
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>BGA</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-name"
                                           v-model="config.bgaNameCity">
                                    <label class="form-check-label" for="bga-name">
                                        Name und Ort
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="bga-dates"
                                           v-model="config.bgaDates">
                                    <label class="form-check-label" for="bga-dates">
                                        Start- und Enddatum
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label><b>Sell-In / Out</b></label>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="show-absatz"
                                           v-model="config.showAbsatz">
                                    <label class="form-check-label" for="show-absatz">
                                        Absatz
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="show-umsatz"
                                           v-model="config.showUmsatz">
                                    <label class="form-check-label" for="show-umsatz">
                                        Umsatz
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Konfiguration</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['flyer.mode']"></i>
                            <b>Modus</b>
                        </label>
                        <select class="form-control" v-model="config.mode">
                            <option value="in">Sell-In: Anbieter und Großhandel - Summe</option>
                            <option value="out">Sell-Out</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['flyer.marketingTool']"></i>
                            <b>Verwende Daten aus dem MarketingTool</b>
                        </label>
                        <select class="form-control" v-model="config.useMarketingTool">
                            <option :value="false">Nein</option>
                            <option :value="true">Ja</option>
                        </select>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3" v-if="config.mode === 'in'">
                    <legend class="w-auto">Sell In</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['flyer.sellInOutBase']"></i>
                            <b>Umsatz Basis</b>
                        </label>
                        <select class="form-control" v-model="config.sellInBase">
                            <option value="listenek">Listen EK</option>
                            <option value="nettoek">Netto EK</option>
                            <option value="listenvk">Listen VK</option>
                            <option value="kalkuliertervk">Kalkulierter VK</option>
                        </select>
                    </div>

                    <div class="form-check my-2" v-if="['listenvk', 'kalkuliertervk'].includes(config.sellInBase)">
                        <input class="form-check-input" type="checkbox" value="" id="sell-in-1-tax"
                               v-model="config.sellInRemoveTax">
                        <label class="form-check-label" for="sell-in-1-tax">
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellOut.removeTax']"></i>
                            Mwst. herausrechnen
                        </label>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3" v-if="config.mode === 'out'">
                    <legend class="w-auto">Sell Out</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['flyer.sellInOutBase']"></i>
                            <b>Umsatz Basis</b>
                        </label>
                        <select class="form-control" v-model="config.sellOutBase">
                            <option value="listenek">Listen EK</option>
                            <option value="nettoek">Netto EK</option>
                            <option value="listenvk">Listen VK</option>
                            <option value="listenvkfallback">Listen VK (Fallback)</option>
                            <option value="tatsaechlichervk">Netto VK</option>
                        </select>
                    </div>

                    <div class="form-check my-2" v-if="['listenvk', 'listenvkfallback', 'tatsaechlichervk'].includes(config.sellOutBase)">
                        <input class="form-check-input" type="checkbox" value="" id="sell-out-tax"
                               v-model="config.sellOutRemoveTax">
                        <label class="form-check-label" for="sell-out-tax">
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['sellOut.removeTax']"></i>
                            Mwst. herausrechnen
                        </label>
                    </div>
                </fieldset>

                <fieldset class="border px-3 mb-3">
                    <legend class="w-auto">Weitere Seiten</legend>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['pages.anbieter']"></i>
                            <b>Anbieter</b>
                        </label>
                        <select class="form-control" v-model="config.pageAnbieter">
                            <option value="disabled">Deaktiviert</option>
                            <option value="simple">Nur Anbieter</option>
                            <option value="extended">Anbieter inklusive PZN</option>
                        </select>
                    </div>
                </fieldset>

                <fieldset class="border px-3" v-if="!(options.disabledFeatures || []).includes('panel_settings')">
                    <legend class="w-auto">Prozentregelung</legend>

                    <div class="form-group" v-if="config.timing.comparePeriods">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['panel.panelPercent']"></i>
                            <b>Panelgröße</b>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Prozent</span>
                            </div>
                            <input type="text" class="form-control" placeholder="100" v-model="config.panelPercent">
                        </div>
                    </div>
                </fieldset>

            </div>
        </div>

        <filtering-module :dto="config.filtering"
                          :options="options"
                          :warengruppen="true"
                          :dar="true"
                          :menge="true"
                          :wirkstoffe="false"
                          :reimport="true"></filtering-module>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingMonthModule from "../Modules/TimingMonthModule";
import FilteringModule from "../Modules/FilteringModule";

export default {
    components: {FilteringModule, TimingMonthModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto
        };
    },
    computed: {

    }
}
</script>
